import React from "react";

const Home = () => (
	<div
		style={{
			backgroundImage: `url("/home.jpg")`,
			backgroundPosition: "center",
			backgroundSize: "cover",
			backgroundRepeat: "no-repeat",
			minHeight: "100%",
			height: "100vh",
			width: "100%",
			position: "absolute",
		}}
	></div>
);
export { Home };
